<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ReportingGroupApi from '../../api/ReportingGroupApi'
/** UI Components */
import { Collapse } from 'buefy/dist/components/collapse'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Loading } from 'buefy/dist/components/loading'
import { Modal } from 'buefy/dist/components/modal'
import { Table,TableColumn } from 'buefy/dist/components/table'
/** Form Components */
import AddUserForm from '../../components/AddUserForm'
import EditUserForm from '../../components/EditUserForm'
import CopyUserForm from '../../components/CopyUserForm'
import ArrayUtil from '../../utilities/ArrayUtil'

const PAGE_SIZE = 10

export default {
    name : "UsersView",
    components: {
        'b-collapse' : Collapse,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-loading' : Loading,
        'b-modal' : Modal,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'AddUserForm' : AddUserForm,
        'CopyUserForm' : CopyUserForm,
        'EditUserForm' : EditUserForm
    },
    computed : {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        }),
        /* groupedData(){
            if (this.searchKeyword=="") {
                if (this.groupByField==null || this.groupBy=='All') {
                    return this.allUsers;
                }
                else {
                    return this.allUsers.filter(user=>{
                        return (user[this.groupByField]==this.groupBy);
                    });
                }
            }
            else {
                var searchKeyword = this.searchKeyword;
                var searchExp = new RegExp(searchKeyword,"i");
                if (this.groupBy=='All') {
                    return this.allUsers.filter(user=>{
                        return (user.fullName.match(searchExp) || 
                                user.username.match(searchExp) ||
                                user.email.match(searchExp) ||
                                user.role.match(searchExp));
                    })
                }
                else {
                    return this.allUsers.filter(user=>{
                        if (user[this.groupByField]==this.groupBy) {
                            return (user.fullName.match(searchExp) || 
                                    user.username.match(searchExp) ||
                                    user.email.match(searchExp) ||
                                    user.role.match(searchExp));
                        }
                    });
                }
            }
        },*/
        existingUsernames(){
            return this.allUsers.filter(user=>{
                return user.username;
            })
        },
        forDeactivation(){
            if (this.tableCheckedRows) {
                return this.tableCheckedRows.filter(row=>{
                    return (row.isActive==1)
                })
            }
        },
        forActivation(){
            if (this.tableCheckedRows) {
                return this.tableCheckedRows.filter(row=>{
                    return (row.isActive==0)
                })
            }
        }
    },
    data(){
        return {
            allUsers: [],
            groupBy : "All",
            groupByField : null,
            repGroupLov : [],
            rolesLov : [],
            showAddUser: false,
            showCopyUser: false,
            showEditUser: false,
            searchKeyword : "",
            selectedUser : null,
            tableCheckboxPosition : "left",
            tableCheckedRows : [],
            isLoading : false,
            isFullPage : false,
            total: 0,
            page: 1,
            pageSize: PAGE_SIZE
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
        // Get LOVs
        this.getRepGroups();
        this.getRoles();
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData", 
            setProfile : "updateUserProfile"
        }),
        isTokenValid(){
            this.isLoading = true;
            if (!this.token) {
                this.isLoading = false;
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.isLoading = false;
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                this.getData();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getRepGroups(){
            this.repGroupLov = [];
            ReportingGroupApi.getAllData()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.repGroupLov = response.data;
                    }
                    else {
                        this.promptServerError({response},'ReportingGroup.getAllGroupData');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingGroup.getAllGroupData');
            })
        },
        getRoles(){
            this.rolesLov = [];
            UserApi.getRoles()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.rolesLov = response.data;
                    }
                    else {
                        this.promptServerError({response},'User.getRoles');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.getRoles');
            });
        },
        getData(){
            this.isLoading = true;
            this.allUsers = [];
            var lowerLimit = ((this.page-1)*this.pageSize) 

            UserApi.search({
                groupBy: this.groupBy,
                groupByField: this.groupByField,
                start: lowerLimit,
                size: this.pageSize,
                keyword: this.searchKeyword
            })
            .then(response=>{
                this.isLoading = false;
                if (response.data) {
                    var d = response.data
                    if (!response.data.error) {
                        this.total = d.total
                        var users = d.data;
                        users.forEach(usr=>{
                            /** Convert date */
                            usr.dateCreated = AppResourceUtil.convertDate(usr.dateCreated)
                            usr.dateUpdated = AppResourceUtil.convertDate(usr.dateUpdated)
                        })
                        this.allUsers = users;
                    }
                    else {
                        this.promptServerError({response},'User.getAll');
                    }
                }
            })
            .catch(error=>{
                this.total = 0
                this.isLoading = false;
                this.promptServerError(error,'User.getAll');
            });
        },
        selectGroupBy(field,value){
            this.page = 1
            this.groupByField = field;
            this.groupBy = value;
            this.getData()
        },
        openAddUser(){
            this.showAddUser = true;
        },
        closeAddUser(){
            this.showAddUser = false;
        },
        submitUsers(users){

            /* users.withUnits.forEach(user=>{
                user.addedBy = this.profile.userId;
            }); */
            users.withHandles.forEach(user=>{
                user.addedBy = this.profile.userId;
            })

            if (users.admin.length > 0) {
                /** No handles */
                users.admin.forEach(user=>{
                    user.addedBy = this.profile.userId;
                }); 

                UserApi.add(users.admin)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            this.getData();
                            this.showAddUser = false;
                            let suffix = "user";
                            if (users.withUnits.length==0) {
                                if ( (users.withoutUnits.length + users.withUnits.length) > 1) {
                                    suffix += "s";
                                }
                                this.$dialog.alert({
                                    title: 'Success',
                                    message: `<p>New ${suffix} added.</p>`,
                                    type: 'is-success'
                                });
                            }
                        }
                        else {
                            this.promptServerError({response},'User.add');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(error,'User.add');
                });
            }

            // this.addUserUnits(users.withUnits,users.withoutUnits.length);
            this.addUserHandles(users.withHandles)
        },
        addUserHandles(users){
            // if (users.length > 0) {
                UserApi.addOne(users)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            this.getData();
                            this.showAddUser = false;

                            // Show add feedback
                            if (numUsers==0) {
                                let suffix = "user";
                                if ( (users.length) > 1) {
                                    suffix += "s";
                                }
                                this.$dialog.alert({
                                    title: 'Success',
                                    message: `<p>New ${suffix} added.</p>`,
                                    type: 'is-success'
                                });
                            }
                        }
                        else {
                            this.promptServerError({response},'User.addOne');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(error,'User.addOne');
                });
            // }
        },

        confirmResetPassword(user){
            var msg = "";
            var selectedUsers = [];
            var requestData = {
                userIds : [],
                updatedBy : this.profile.userId
            };

            if (user) {
                msg = 'Are you sure you want to <b>reset</b> the password of user <b>'+user.fullName+'</b>? This action cannot be undone.';
                selectedUsers.push(user);
            }   
            else { // Bulk reset password
                let obj = "user";
                if (this.tableCheckedRows.length > 1) {
                    obj += "s";
                }
                msg = 'Are you sure you want to <b>reset</b> the password of <b>'+this.tableCheckedRows.length+'</b> selected '+obj+'? This action cannot be undone.';
                selectedUsers = this.tableCheckedRows;
            }

            if (selectedUsers.length) {
                selectedUsers.forEach(user=>{
                    requestData.userIds.push(user.userId);
                })
            }

            this.$dialog.confirm({
                title: 'Confirm Reset Password',
                message: msg,
                confirmText: 'Reset Password',
                type: 'is-warning',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                onConfirm: () => this.resetPassword(requestData)
            });
        },
        resetPassword(reqData){
            UserApi.resetPassword(reqData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p>Password is reset to <strong>eiti123!</strong></p>",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.promptServerError({response},'User.resetPassword');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.resetPassword');
            });
        },

        confirmDeactivateProfile(user){
            var msg = "";

            var selectedUsers = [];
            var requestData = {
                userIds : [],
                updatedBy : this.profile.userId
            };

            if (user) {
                if (user.isActive==false) {
                    // Activate
                    requestData.userIds.push(user.userId);
                    this.activateProfile(requestData);
                    return false;
                }
                msg = 'Are you sure you want to <b>deactivate</b> user <b>'+user.fullName+'</b>? This action cannot be undone.';
                selectedUsers.push(user);
            }   
            else { // Bulk reset password
                let obj = "user";
                if (this.tableCheckedRows.length > 1) {
                    obj += "s";
                }
                msg = 'Are you sure you want to <b>deactivate</b> <b>'+this.tableCheckedRows.length+'</b> selected '+obj+'? This action cannot be undone.';
                selectedUsers = this.forDeactivation;
            }

            if (selectedUsers.length) {
                selectedUsers.forEach(user=>{
                    requestData.userIds.push(user.userId);
                })
            }

            this.$dialog.confirm({
                title: 'Confirm Deactivate',
                message: msg,
                confirmText: 'Deactivate',
                type: 'is-warning',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                onConfirm: () => this.deactivateProfile(requestData)
            });
        },
        deactivateProfile(reqData){
            UserApi.deactivate(reqData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.$notification.open({
                            duration: 5000,
                            message: 'Profiles deactivated.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'User.deactivate');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.deactivate');
            });
        },

        confirmActivateProfile(user){
            var selectedUsers = this.forActivation;
            var requestData = {
                userIds : [],
                updatedBy : this.profile.userId
            };
            if (selectedUsers.length) {
                selectedUsers.forEach(user=>{
                    requestData.userIds.push(user.userId);
                })
            }
            this.activateProfile(requestData);
        },
        activateProfile(reqData) {
            UserApi.activate(reqData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.$notification.open({
                            duration: 5000,
                            message: 'Profiles activated.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'User.activate');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.activate');
            });
        },

        confirmDeleteProfile(user){
            var msg = "";
            var selectedUsers = [];
            var requestData = {
                userIds : [],
                deletedBy : this.profile.userId,
                deleteLimit: 0
            };

            if (user) {
                msg = 'Are you sure you want to <b>delete</b> user <b>'+user.fullName+'</b>? This action cannot be undone.';
                selectedUsers.push(user);
            }   
            else { // Bulk reset password
                let obj = "user";
                if (this.tableCheckedRows.length > 1) {
                    obj += "s";
                }
                msg = 'Are you sure you want to <b>delete</b> <b>'+this.tableCheckedRows.length+'</b> selected '+obj+'? This action cannot be undone.';
                selectedUsers = this.tableCheckedRows;
            }

            if (selectedUsers.length) {
                requestData.deleteLimit = 0
                selectedUsers.forEach(user=>{
                    requestData.userIds.push(user.userId);
                    requestData.deleteLimit = requestData.deleteLimit + (user.reportingEntities.length + user.reportingUnits.length)
                })
            }

            this.$dialog.confirm({
                title: 'Confirm Delete',
                message: msg,
                confirmText: 'Delete',
                type: 'is-warning',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                onConfirm: () => this.deleteProfile(requestData)
            });
        },
        deleteProfile(reqData){
            UserApi.delete(reqData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        /** 
                         * If there are active table selection,
                         * clear selected
                         */
                        if (this.tableCheckedRows.length > 0) {
                            this.tableCheckedRows = []
                        }
                        this.$notification.open({
                            duration: 5000,
                            message: 'Deleted.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'User.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.delete');
            });
        },

        openEditProfile(user){
            this.showEditUser = true;
            this.selectedUser = user;

            this.$set(this.selectedUser,'tempData',{});
            this.$set(this.selectedUser.tempData,'userId',this.selectedUser.userId);
            this.$set(this.selectedUser.tempData,'username',this.selectedUser.username);
            this.$set(this.selectedUser.tempData,'firstName',this.selectedUser.firstName);
            this.$set(this.selectedUser.tempData,'lastName',this.selectedUser.lastName);
            this.$set(this.selectedUser.tempData,'email',this.selectedUser.email);
            this.$set(this.selectedUser.tempData,'isActive',this.selectedUser.isActive);

            this.$set(this.selectedUser.tempData,'roleId',this.selectedUser.roleIdFk);  
            this.$set(this.selectedUser.tempData,'repEntityId',this.selectedUser.repEntityIdFk);
            this.$set(this.selectedUser.tempData,'repGroupId',this.selectedUser.repGroupIdFk);
            
            this.$set(this.selectedUser.tempData,'handleKeyword','');
            this.$set(this.selectedUser.tempData,'selectedEntitiesOnly', false)
            this.$set(this.selectedUser.tempData,'selectedUnitsOnly', false)
            this.$set(this.selectedUser.tempData,'repEntityHandles',[]);

            if (user.reportingEntities.length > 0) {
                this.selectedUser.tempData.selectedEntitiesOnly = true
                // repEntityHandles -> list of repEntityId's
                this.selectedUser.tempData.repEntityHandles = user.reportingEntities.map(ent=>{
                    return ent.repEntityIdFk
                })
            }
            // Add count validation forms assigned to each unit, here ^^^

            // DON'T ALLOW ADMIN to delete reporting units with validation forms already
            this.$set(this.selectedUser.tempData,'repUnits',[]);
            if (user.reportingUnits.length > 0) {
                this.selectedUser.tempData.selectedUnitsOnly = true
                // repUnits -> list of repUnitId's
                this.selectedUser.tempData.repUnits = user.reportingUnits.map(unit=>{
                    return unit.repUnitIdFk
                })
            }
        },
        closeEditProfile(){
            this.showEditUser = false;
            this.selectedUser = null;
        },
        updateProfile(arg){
            var userData = arg.data
            const resetLevel = arg.resetLevel
            
            if (userData.email) {
                // Back-end services uses emailAddress
                userData.emailAddress = userData.email;
            }
            this.showEditUser = false;
            userData.updatedBy = this.profile.userId;
            
            UserApi.update(userData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        /** 
                         * Assumption:
                         * All user rep units and user.repEntiyIdFk are migrated to user_handles
                         * */
                        if (resetLevel !== '') {
                            this.prepNewUserHandles(arg)
                        } else {
                            this.getData()
                            this.$dialog.alert({
                                title: 'Success',
                                message: `<p>User profile updated.</p>`,
                                type: 'is-success'
                            });    
                        }
                        /** Old implementation: 
                        if (userData.repUnits.length == 0) {
                            if (userData.resetUnits==false) {
                                this.getData();
                                this.$dialog.alert({
                                    title: 'Success',
                                    message: `<p>User profile updated.</p>`,
                                    type: 'is-success'
                                });
                            }
                            else {
                                this.deleteUserUnits(userData);
                            }
                        }
                        else {
                            this.prepNewUserUnits(userData);
                        }*/
                    }
                    else {
                        this.promptServerError({response},'User.update');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.update');
            });
        },
        getUnitEntity(repUnitId) {
            /** Returns reporting entity info given a repUnitId */
            var data = null
            if (this.repGroupLov) {
                this.repGroupLov.forEach(grp => {
                    var repEnt = grp.reportingEntities.filter(ent => {
                        var res = ent.reportingUnits.filter(unit => {
                            return unit.repUnitId === repUnitId
                        })
                        return res.length > 0
                    })
                    if (repEnt.length > 0) {
                        data = repEnt[0]
                    }
                })
            }
            return data
        },
        prepNewUserHandles(param) {
            var userData = param.data
            /** 
             * Delete existing entities and
             * add new entities
             */
            let data = {
                userIds : [userData.userId],
                userId : userData.userId,
                userEntities : [],
                userUnits: [],
                deleteLimit: 0
            };

            var existingEntities = this.selectedUser.reportingEntities.map(ent => {
                return ent.repEntityIdFk
            })
            var existingUnits = this.selectedUser.reportingUnits.map(unit => {
                return unit.repUnitIdFk
            })
            
            /** Used to limit the number of rows to be removed in the DB */
            data.deleteLimit = existingEntities.length + existingUnits.length

            if (userData.repEntityHandles.length > 0) {
                data.userEntities = userData.repEntityHandles.map(entityId=>{    
                    return {
                        repEntityIdFk: entityId,
                        repUnitIdFk : null
                    }
                })
            }
            
            if (userData.repUnits.length > 0) {
                data.userUnits = userData.repUnits.map(unitId=>{    
                    var currUnitData = {
                        repUnitIdFk: unitId,
                        repEntityIdFk: null
                    }
                    var repUnitEntity = this.getUnitEntity(unitId)
                    if (repUnitEntity !== null) {
                        currUnitData.repEntityIdFk = repUnitEntity.repEntityId
                    }
                    return currUnitData
                })
            }

            this.updateUserHandles(data);
        },
        prepNewUserUnits(userData) {
            /** 
             * Delete existing units and
             * add new units
             */
            let data = {
                userIds : [userData.userId],
                userId : userData.userId,
                userUnits : []
            };
            if (userData.repUnits.length > 0) {
                userData.repUnits.forEach(unitId=>{
                    data.userUnits.push({
                        repUnitIdFk : unitId
                    })
                })
            } 
            this.updateUserUnits(data);
        },
        deleteHandles(userData) {
            
            /** To reset/delete existing handles */
            var data = {
                userIds : [userData.userId],
                userEntities: [],
                userUnits: []
            }
            if (userData.resetHandles ===true) {
                data.userEntities = []
            }
            if (userData.resetUnits === true) {
                data.userUnits = []
            }
            console.log(data)
            console.log(userData)
            console.log('in delete handles')
            // if (userData.resetUnits===true) { 
            //     data.userUnits = []
            //     this.updateUserUnits(data);
            // }
            // this.updateUserHandles(data)
        },
        deleteUserUnits(userData){
            /** To reset/delete existing units */
            if (userData.resetUnits==true) {
                let data = {
                    userIds : [userData.userId],
                    userUnits : []
                };
                this.updateUserUnits(data);
            }
        },  
        updateUserHandles(data) {
            if (!data) {
                return false;
            }
            data.addedBy = this.profile.userId;
            UserApi.updateHandles(data)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            this.getData();
                            this.$dialog.alert({
                                title: 'Success',
                                message: `<p>User profile updated.</p>`,
                                type: 'is-success'
                            });
                        }
                    }
                    else {
                        this.promptServerError({response},'User.updateUnits');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.updateUnits');
            });
        },
        updateUserUnits(data) {
            if (!data) {
                return false;
            }
            UserApi.updateUnits(data)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            this.getData();
                            this.$dialog.alert({
                                title: 'Success',
                                message: `<p>User profile updated.</p>`,
                                type: 'is-success'
                            });
                        }
                    }
                    else {
                        this.promptServerError({response},'User.updateUnits');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.updateUnits');
            });
        },

        openCopyProfile(user){
            this.showCopyUser = true;
            this.selectedUser = user;

            this.$set(this.selectedUser,'tempData',{});
            this.$set(this.selectedUser.tempData,'username','');
            this.$set(this.selectedUser.tempData,'firstName','');
            this.$set(this.selectedUser.tempData,'lastName','');
            this.$set(this.selectedUser.tempData,'email','');
            this.$set(this.selectedUser.tempData,'isActive',this.selectedUser.isActive);

            this.$set(this.selectedUser.tempData,'roleId',this.selectedUser.roleIdFk);  
            this.$set(this.selectedUser.tempData,'repEntityId',this.selectedUser.repEntityIdFk);
            this.$set(this.selectedUser.tempData,'repGroupId',this.selectedUser.repGroupIdFk);
            
            this.$set(this.selectedUser.tempData,'handleKeyword','');
            this.$set(this.selectedUser.tempData,'selectedEntitiesOnly', false)
            this.$set(this.selectedUser.tempData,'selectedUnitsOnly', false)
            this.$set(this.selectedUser.tempData,'repEntityHandles',[]);

            if (user.reportingEntities.length > 0) {
                this.selectedUser.tempData.selectedEntitiesOnly = true
                // repEntityHandles -> list of repEntityId's
                this.selectedUser.tempData.repEntityHandles = user.reportingEntities.map(ent=>{
                    return ent.repEntityIdFk
                })
            }
            // Add count validation forms assigned to each unit, here ^^^

            // DON'T ALLOW ADMIN to delete reporting units with validation forms already
            this.$set(this.selectedUser.tempData,'repUnits',[]);
            if (user.reportingUnits.length > 0) {
                this.selectedUser.tempData.selectedUnitsOnly = true
                this.selectedUser.tempData.repUnits = user.reportingUnits.map(unit=>{
                    return unit.repUnitIdFk
                })
                // user.reportingUnits.forEach(unit=>{
                //     this.selectedUser.tempData.repUnits.push(unit.repUnitIdFk);
                // })
            }
        },
        closeCopyProfile(){
            this.showCopyUser = false;
        },
        copyProfile(userData){
            userData.addedBy = this.profile.userId;
            userData.userUnits = [];
            userData.userEntities = [];

            if (userData.repEntityHandles.length > 0) {
                userData.userEntities = userData.repEntityHandles.map(entityId=>{    
                    return {
                        repEntityIdFk: entityId,
                        repUnitIdFk : null
                    }
                })
            }
            
            if (userData.repUnits.length > 0) {
                userData.userUnits = userData.repUnits.map(unitId=>{    
                    var currUnitData = {
                        repUnitIdFk: unitId,
                        repEntityIdFk: null
                    }
                    var repUnitEntity = this.getUnitEntity(unitId)
                    if (repUnitEntity !== null) {
                        currUnitData.repEntityIdFk = repUnitEntity.repEntityId
                    }
                    return currUnitData
                })
            }

            /* Old implementation
            if (userData.repUnits.length > 0) {
                userData.repUnits.forEach(unit=>{
                    userData.userUnits.push({
                        repUnitIdFk : unit
                    });
                });
            } */

            if (userData.email) {
                // emailAddress is used in back-end
                userData.emailAddress = userData.email;
            }

            UserApi.addOne([userData])
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                        this.showCopyUser = false;
                        this.$dialog.alert({
                            title: 'Success',
                            message: `<p>User profile created.</p>`,
                            type: 'is-success'
                        });
                    }
                    else {
                        this.promptServerError({response},'User.addOne');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.addOne');
            });
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        onPageChange (page) {
            this.page = page
            this.getData()
        },
        runSearch () {
            if (this.searchKeyword && this.searchKeyword.trim() !== '') {
                this.page = 1
                this.getData()
            }
        },
        clearSearch () {
            this.page = 1
            this.groupBy = 'All'
            this.groupByField = null
            this.searchKeyword = ''
            this.getData()
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Users</p>
        
        <section class="section no-padd--top"> 
            <!-- Filter Options /Search -->
            <div class="columns">
                <div class="column is-narrow">
                    <div class="field is-grouped">
                        <div class="control">
                            <b-dropdown
                                v-model="groupBy">
                                <button class="button is-primary is-outlined"
                                    type="button"
                                    slot="trigger">
                                    <template v-if="groupBy=='All'">
                                        <strong>All Users</strong>
                                    </template>
                                    <template v-else>
                                        <strong>{{groupBy}}</strong>
                                    </template>
                                    <b-icon icon="menu-down"></b-icon>
                                </button>

                                <b-dropdown-item
                                    v-bind:value="'All'"
                                    v-on:click="selectGroupBy(null,'All')">
                                    <h4>All Users</h4>
                                </b-dropdown-item>
                                
                                <hr class="dropdown-divider">

                                <b-dropdown-item
                                    v-for="(role,roleIdx) in rolesLov"
                                    :key="(repGroupLov.length + roleIdx)"
                                    v-bind:value="role.roleName"
                                    v-on:click="selectGroupBy('role',role.roleName)">
                                    <h4>{{role.roleName}} Role</h4>
                                </b-dropdown-item>

                                <hr class="dropdown-divider">

                                <b-dropdown-item
                                    v-for="(repGroup,repGrpIdx) in repGroupLov"
                                    :key="repGrpIdx"
                                    v-bind:value="repGroup.reportingGroup"
                                    v-on:click="selectGroupBy('reportingGroup',repGroup.reportingGroup)">
                                    <h4>From {{repGroup.reportingGroup}}</h4>
                                </b-dropdown-item>

                            </b-dropdown>
                        </div>
                        <b-field>
                            <b-input placeholder="Entery keyword"
                                type="search"
                                icon="magnify"
                                v-model="searchKeyword"
                                v-on:keypress.13.native="runSearch"                
                                icon-right="close-circle"
                                icon-right-clickable
                                @icon-right-click="clearSearch">
                            </b-input>
                            <p class="control">
                                <button class="button is-info"
                                    @click="runSearch">Search User</button>
                            </p>
                        </b-field>
                        <b-field>
                            <p class="control">
                                <a
                                    class="button is-info is-inverted"
                                    v-on:click="clearSearch">
                                    Reset Search
                                </a>
                            </p>
                        </b-field>
                        <div class="separator-v"></div>
                        <button type="button"
                            class="button is-primary"
                            v-on:click="openAddUser">
                            <span class="icon">
                                <i class="fas fa-plus"></i>
                            </span>
                            <span>Add User</span>
                        </button>
                    </div>
                </div>
                <!-- <div class="column has-text-right">    
                </div> -->
            </div>

            <section class="base-box--loading"
                v-if="isLoading">
                <b-loading 
                    v-bind:is-full-page="isFullPage" 
                    v-bind:active.sync="isLoading"
                    >
                    <b-icon
                        pack="fas"
                        icon="sync-alt"
                        size="is-medium"
                        custom-class="fa-spin">
                    </b-icon>
                    &nbsp;&nbsp;&nbsp;
                    <span class="title is-5">Loading users</span>
                </b-loading>
            </section> 

            <section class="section no-padd app-view app-view--admin"
                v-if="allUsers.length > 0 && !isLoading">

                <div>
                    
                    <b-field grouped group-multiline>
                        <!-- <div class="field">
                            <span>
                                Total seleted: {{tableCheckedRows.length}}
                            </span>
                        </div> -->

                        <div class="field">
                            <div class="tags has-addons">
                                <span class="tag is-medium has-text-primary has-text-weight-bold">
                                    {{tableCheckedRows.length}} selected
                                </span>
                                <a class="tag has-text-primary  is-delete is-medium"
                                    v-if="tableCheckedRows.length > 0"
                                    v-on:click="tableCheckedRows = []"
                                    title="Clear selected"></a>
                            </div>
                        </div>

                        <!-- <button class="button field"
                            v-on:click="tableCheckedRows = []"
                            v-bind:disabled="tableCheckedRows.length==0">
                            <span>Clear selected</span>
                        </button> -->

                        <div class="field">
                            <button class="button has-text-grey"
                                v-on:click="confirmResetPassword(null)"
                                v-bind:disabled="tableCheckedRows.length==0">
                                <span>Reset Password</span>
                            </button>
                        </div>

                        <div class="field">
                            <button class="button has-text-info"
                                v-on:click="confirmDeactivateProfile(null)"
                                v-bind:disabled="forDeactivation.length==0">
                                <span>Deactivate</span>
                            </button>
                        </div>

                        <div class="field">
                            <button class="button has-text-info"
                                v-on:click="confirmActivateProfile(null)"
                                v-bind:disabled="forActivation.length==0">
                                <span>Activate</span>
                            </button>
                        </div>

                        <div class="field">
                            <button class="button has-text-danger"
                                v-on:click="confirmDeleteProfile(null)"
                                v-bind:disabled="tableCheckedRows.length==0">
                                <span>Delete</span>
                            </button>
                        </div>
                    </b-field>

                    <!-- table here -->
                    <b-table
                        v-bind:striped="true"
                        v-bind:mobile-cards="true"
                        v-bind:data="allUsers"
                        v-bind:checked-rows.sync="tableCheckedRows"
                        checkable
                        v-bind:checkbox-position="tableCheckboxPosition"
                        
                        paginated
                        backend-pagination
                        v-bind:current-page="page"
                        v-bind:per-page="pageSize"
                        v-bind:total="total"
                        v-on:page-change="onPageChange"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page">

                        <template
                            slot-scope="props">

                            <b-table-column
                                field="username"
                                label="Username"
                                width="120"
                                sortable>
                                {{props.row.username}}
                            </b-table-column>

                            <b-table-column
                                field=""
                                label=""
                                width="50">
                                <b-dropdown>
                                    <button type="button"
                                        class="button is-small is-light"
                                        slot="trigger"
                                        role="button">
                                        <span class="icon fa-sm">
                                            <i class="fas fa-ellipsis-v fa-lg"></i>
                                        </span>
                                    </button>

                                    <b-dropdown-item
                                        v-on:click="confirmResetPassword(props.row)">
                                        <b-icon size="fa-sm" 
                                            pack="fas"
                                            icon="lock">
                                        </b-icon>
                                        Reset Password
                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        v-on:click="openCopyProfile(props.row)">
                                        <b-icon size="fa-sm" 
                                            pack="fas"
                                            icon="copy">
                                        </b-icon>
                                        Copy Account Profile
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider">

                                    <b-dropdown-item
                                        v-on:click="openEditProfile(props.row)">
                                        <b-icon size="fa-sm" 
                                            pack="fas"
                                            icon="pen">
                                        </b-icon>
                                        Edit
                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        v-on:click="confirmDeactivateProfile(props.row)">
                                        <b-icon size="fa-sm" 
                                            pack="fas"
                                            icon="ban">
                                        </b-icon>
                                        {{props.row.isActive==true ? 'Deactivate' : 'Activate' }}
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider">

                                    <b-dropdown-item
                                        v-on:click="confirmDeleteProfile(props.row)">
                                        <b-icon size="fa-sm" 
                                            pack="fas"
                                            icon="trash">
                                        </b-icon>
                                        Delete permanently
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-table-column>

                            <b-table-column
                                field="fullName"
                                label="Name"
                                width="175">
                                {{props.row.fullName}}
                            </b-table-column>

                            <b-table-column
                                field="role"
                                label="Role"
                                width="175">
                                {{props.row.role}}
                            </b-table-column>

                            <b-table-column
                                field="repGroupTagClass"
                                label="Reporting Group"
                                width="200">
                                <div v-if="props.row.reportingGroups && props.row.reportingGroups.length > 0">
                                    <span class="tag"
                                        v-for="(grp,grpIdx) in props.row.reportingGroups"
                                        v-bind:key="grpIdx"
                                        v-bind:class="grp.repGroupTagClass">
                                        {{grp.reportingGroup}}
                                    </span>
                                </div>
                                <div v-else>
                                    <span class="tag"
                                        v-if="props.row.role!='Admin' && props.row.role!='Independent Administrator' && props.row.repGroupTagClass"  
                                        v-bind:class="props.row.repGroupTagClass">
                                        {{props.row.reportingGroup}}
                                    </span>
                                </div>
                            </b-table-column>

                            <b-table-column
                                field="reportingEntity"
                                label="Reporting Entity"
                                width="175">
                                <div v-if="props.row.reportingEntities && props.row.reportingEntities.length">
                                    <span
                                        v-for="(ent,entIdx) in props.row.reportingEntities"
                                        v-bind:key="entIdx">
                                        <span v-if="entIdx > 0">,&nbsp;</span>
                                        {{ent.reportingEntity}}
                                    </span>
                                </div>
                                <div v-else>
                                    {{props.row.reportingEntity}}
                                </div>
                            </b-table-column>

                            <b-table-column
                                field="reoprtingUnits"
                                label="Reporting Unit"
                                width="175">
                                <div>
                                    <span
                                        v-for="(unit,unitIdx) in props.row.reportingUnits"
                                        v-bind:key="unitIdx">
                                        <span v-if="unitIdx > 0">,&nbsp;</span>
                                        {{unit.reportingUnit}}
                                    </span>
                                </div>
                            </b-table-column>

                            <b-table-column
                                field="email"
                                label="Email"
                                width="175">
                                {{props.row.email}}
                            </b-table-column>

                            <b-table-column
                                field="isActive"
                                label="Status"
                                width="100"
                                centered>
                                <span class="tag has-text-weight-bold"
                                    :class="props.row.isActive ? 'has-text-success' : 'has-text-grey'">
                                    {{props.row.isActive ? 'Active' : 'Inactive' }}
                                </span>
                            </b-table-column>

                            <b-table-column
                                label="Logs"
                                width="100"
                                centered>
                                <b-dropdown 
                                    aria-role="list" 
                                    position="is-bottom-left">
                                    <button type="button"
                                        class="button is-small is-light"
                                        slot="trigger"
                                        role="button">
                                        <span class="icon fa-sm">
                                            <i class="fas fa-ellipsis-h fa-lg"></i>
                                        </span>
                                    </button>
                                    <b-dropdown-item aria-role="listitem">
                                        <div>
                                            <strong>Last updated by: </strong> {{props.row.updatedByName}}<br/>
                                            <strong>Last updated on: </strong> {{props.row.dateUpdated}}
                                        </div>
                                        <hr class="dropdown-divider">
                                        <div>
                                            <strong>Created by: </strong> {{props.row.createdByName}}<br/>
                                            <strong>Date created: </strong> {{props.row.dateCreated}}
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-table-column>
                        </template>

                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>No user found.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>
                </div> 

            </section>

            <!-- Empty State -->
            <section class="section no-padd app-view app-view--admin"
                v-if="allUsers.length==0 && !isLoading">
                <div
                    class="has-text-centered empty-state-box empty-state-box--white">
                    <div class="has-text-centered">

                        <p class="title is-5">There are no users found.</p>
                        <p class="subtitle">
                            To start adding users, click 'Add User' button or click 
                            <a v-on:click="openAddUser">here</a>.
                        </p>
                        
                    </div>

                </div>
            </section>
            
        </section>  

        <!-- Add User -->
        <b-modal
            v-bind:active.sync="showAddUser"
            full-screen
            :can-cancel="false"
            v-on:close="closeAddUser">
            <AddUserForm 
                v-bind:repGroupList="repGroupLov"
                v-bind:rolesList="rolesLov"
                v-bind:profile="profile"
                v-on:close="closeAddUser"
                v-on:submit-users="submitUsers"/>
        </b-modal>

        <!-- Edit User -->
        <b-modal
            v-bind:active.sync="showEditUser"
            :can-cancel="false"
            v-on:close="closeEditProfile">
            <EditUserForm 
                v-bind:repGroupList="repGroupLov"
                v-bind:rolesList="rolesLov"
                v-bind:data="selectedUser"
                v-bind:profile="profile"
                v-on:close="closeEditProfile"
                v-on:save-profile="updateProfile"/>
        </b-modal>

        <!-- Edit User -->
        <b-modal
            v-bind:active.sync="showCopyUser"
            :can-cancel="false"
            v-on:close="closeCopyProfile">
            <CopyUserForm 
                v-bind:repGroupList="repGroupLov"
                v-bind:rolesList="rolesLov"
                v-bind:data="selectedUser"
                v-bind:profile="profile"
                v-on:close="closeCopyProfile"
                v-on:save-profile-copy="copyProfile"/>
        </b-modal>
    </section>
</template>

<style scoped>
.collapse-header {
    background-color: whitesmoke;
}

.separator-v {
    display: inline-block;
    width:2px;
    height:17px;
    margin:0.6rem auto;
    margin-left: 0.7rem;
    margin-right: 0.7rem;
    border:none;
    border-right: 1px solid #ccc;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/UsersView.vue